import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import FractalApp from "./FractalApp";
import About from "./About";

const theme = createTheme();

export default function App() {
  return (
    <BrowserRouter basename="/fractal">
      <Routes>
        <Route path="/" element={<FractalApp />} />
		<Route path="/about" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
